import { addRecentSearch, createSearchStableQueries, toEnglish } from '@/helpers/props';
import { useRouter } from 'next/router';
import { memo, useEffect, useMemo, useRef, useState } from 'react';
import Icon from '@/components/UI/icon/Icon';
import SearchDropdown from '@/components/reusable/home/searchDropDown/SearchDropDown';
import useRouterBack from '@/hooks/useRouterBack';
import styles from './FiltersSearchBox.module.scss';
import Box from '@/components/UI/box/Box';
import IconButton from '@/components/UI/iconButton/IconButton';
import useSearchParams from '@/components/search/hooks/useSearchParams';
export const CITIES_WITH_NEAR: string[] = ['کردان', 'کیش', 'تهران', 'محمود آباد', 'چالوس', 'رامسر', 'کرج', 'رشت', 'ماسال', 'اصفهان'];
const FiltersSearchbox = () => {
  const {
    params,
    queries
  } = useSearchParams();
  const isMidTerm = !!queries?.mid_term && params.city === 'تهران';
  const locationType = useMemo(() => params.city || params.province || params.phrase, [params.city, params.phrase, params.province]);
  const [searchTxt, setSearchTxt] = useState<string | string[]>(isMidTerm ? 'جستجو در محله های تهران' : locationType ?? '');
  const [searchboxOpen, setSearchboxOpen] = useState<boolean>(false);
  const searchInput = useRef<HTMLInputElement>(null);
  const searchRef = useRef<any>(null);
  const {
    handleBack
  } = useRouterBack();
  const router = useRouter();
  const handleSearch = e => setSearchTxt(e.target.value);
  useEffect(() => {
    setSearchTxt(isMidTerm ? queries.phrase || 'جستجو در محله های تهران' : locationType);
  }, [locationType, isMidTerm, queries.phrase]);
  const handleClickCity = (cityName: string, type: string = 'city', data: any = {}) => {
    const mainQuery: any = {
      ...queries,
      ...createSearchStableQueries()
    };
    const txtItem = {
      date: '',
      name: cityName,
      type
    };
    setSearchboxOpen(false);
    const {
      special_discount,
      special_discount_city,
      special_discount_province,
      ['user_co_ordinates[longitude]']: userCoordinatesLongitude,
      ['user_co_ordinates[latitude]']: userCoordinatesLatitude,
      co_ordinates,
      page,
      near_cities,
      phrase,
      from_map_nearby,
      ['swiss-cottage']: swissCottage,
      ...restMainQueries
    } = mainQuery;
    if (type === 'phrase' && isMidTerm) {
      return router.push({
        pathname: `/search/city/تهران`,
        query: {
          ...restMainQueries,
          mid_term: 1,
          phrase: cityName
        }
      });
    }
    setSearchTxt(cityName);
    setTimeout(() => {
      if (type === 'city' || type === 'province' || type === 'village') {
        router.push({
          pathname: `/search/${type}/${cityName}`,
          query: restMainQueries
        });
      }
      if (type === 'phrase') {
        let resultUrl = '';
        if (searchRef.current?.allResult?.length) {
          resultUrl = `/search/${searchRef.current?.allResult?.[0]?.type}/${searchRef.current?.allResult?.[0]?.name}`;
          txtItem.type = searchRef.current?.allResult?.[0]?.type;
        }
        if (resultUrl) {
          router.push({
            pathname: resultUrl,
            query: restMainQueries
          });
        } else {
          // +toEnglish checks if search text is house id
          if (+toEnglish(cityName)) {
            router.push({
              pathname: `/search`,
              query: {
                ...restMainQueries,
                phrase: +toEnglish(cityName)
              }
            });
            txtItem.name = toEnglish(searchTxt);
          } else {
            router.push({
              pathname: `/search`,
              query: {
                ...restMainQueries,
                phrase: cityName
              }
            });
          }
        }
      }
      addRecentSearch(txtItem); // saves search history in localStorage by phrase | city | province
    }, 0);
  };
  const handleCleanClose = () => {
    if (isMidTerm) {
      setSearchTxt(queries.phrase || 'جستجو در محله های تهران');
    } else if (locationType) {
      if (locationType !== searchTxt) {
        setSearchTxt(locationType);
      }
    } else {
      setSearchTxt('');
    }
  };
  return <>
      <Box className={styles['filters-search-box-container']} data-sentry-element="Box" data-sentry-source-file="FiltersSearchbox.tsx">
        {router.pathname.includes('/search') && <IconButton format="text" onClick={handleBack} className={styles['search-button']} icon="arrow-right-1" />}
        <Box className={styles['container']} data-sentry-element="Box" data-sentry-source-file="FiltersSearchbox.tsx">
          <Box onClick={e => {
          e.stopPropagation();
          setSearchboxOpen(true);
        }} className={styles['search-icon-container']} data-sentry-element="Box" data-sentry-source-file="FiltersSearchbox.tsx">
            <Icon name="search-normal" type="highEmphasis" size="small" data-sentry-element="Icon" data-sentry-source-file="FiltersSearchbox.tsx" />
          </Box>
          <input type="text" className={styles['input']} placeholder="جستجوی شهر یا کد آگهی" onClick={() => {
          setSearchTxt('');
          setSearchboxOpen(true);
        }} ref={searchInput} value={searchTxt} onChange={handleSearch} />
          <SearchDropdown handleClickCity={handleClickCity} open={searchboxOpen} searchTxt={searchTxt} setSearchTxt={setSearchTxt} setOpen={setSearchboxOpen} searchInputRef={searchInput} handleCleanClose={handleCleanClose} ref={searchRef} isMidTerm={isMidTerm} data-sentry-element="SearchDropdown" data-sentry-source-file="FiltersSearchbox.tsx" />
        </Box>
      </Box>
    </>;
};
export default memo(FiltersSearchbox);